import { compact } from '@lglp/utils';
import moment from 'moment';

import { DocumentType } from '../../types/document';
import { and, attr, period } from '../algolia/algolia-filters-builder';

export const searchFinancialPressRelease = ({
  hitsPerPage = 500,
  year,
}: SearchFinancialPressReleaseProps = {}): SearchFinancialPressReleaseReturnProps => {
  const currentYear = new Date(Date.now()).getFullYear();
  return compact<SearchFinancialPressReleaseReturnProps>({
    hitsPerPage,
    filters: and([
      attr('type', DocumentType.PRESS_RELEASE),
      period(
        'release_date',
        moment(`${year || currentYear}0101`, 'YYYYMMDD').valueOf(),
        moment(`${year || currentYear}1231`, 'YYYYMMDD').valueOf()
      ),
      // then filter by the form parameters:
      attr('onFinance', 'true'),
    ]),
  });
};

type SearchFinancialPressReleaseProps = {
  hitsPerPage?: number;
  year?: string;
};

type SearchFinancialPressReleaseReturnProps = {
  hitsPerPage: number;
  filters: string;
};
